import DocumentRecipes_1_0_0 from './DocumentRecipes_1_0_0.js';
import DocumentRecipes_1_1_0 from './DocumentRecipes_1_1_0.js';
const DocumentRecipes = [...DocumentRecipes_1_0_0, ...DocumentRecipes_1_1_0];
export default DocumentRecipes;
//# sourceMappingURL=DocumentRecipes.js.map